import { Layers, IconLayerOptions, PolygonLayerOptions } from '../models';
import { MapLayerRenderer } from '../mapbox-map-layer-renderer';
import { MapboxHelper } from '../mapbox-map-helper';
import { Theme } from 'src/app/modules/shared/models';

import * as _ from 'lodash';

export class RenderStopsTilesetLayer extends MapLayerRenderer {
    constructor(
        protected _mapboxHelper: MapboxHelper,
        private _theme: Theme = Theme.Light
    ) {
        super(_mapboxHelper);
    }

    protected modifyFeatureCollection(fc: GeoJSON.FeatureCollection): GeoJSON.FeatureCollection {
        return fc;
    }

    protected renderLayers(map: mapboxgl.Map): void {
        const layers = {};
        layers[Layers.StopsTileset] = [];

        const stopTilesetIconlayerId = `${Layers.StopsTileset}`;
        if (!this._mapboxHelper.layerExists(map, stopTilesetIconlayerId)) {
            let layerNames = [];
            const options = this._mainStopOptions();
            layerNames = this._mapboxHelper.renderIcon(map, this._sourceId, this._sourceLayer, stopTilesetIconlayerId, options);
            layers[Layers.StopsTileset] = layers[Layers.StopsTileset].concat(layerNames);
        }

        this.addLayerNames(layers);
    }

    //#region rendering options for layers connected to stops
    private _mainStopOptions(): IconLayerOptions {
        const options = new IconLayerOptions();
        options.interactive = false;
        options.icon = ['step', ['zoom'], 'dot-10', 15, 'stop'];
        options.iconSize = [
            'step',
            ['zoom'],
            0,
            7,
            0.3,
            10,
            0.7,
            11,
            1,
            15,
            0.6
        ];
        options.text = ['to-string', ['get', 'title']];
        options.textSize = [
            'interpolate',
            ['linear'],
            ['zoom'],
            0,
            10,
            15,
            11,
            16,
            12,
            22,
            12
        ];
        options.textOffset = [
            'step',
            ['zoom'],
            ['literal', [0, -0.5]],
            15,
            ['literal', [0, -0.9]]
        ];
        options.textFont = ['case',
            ['boolean', ['get', 'isSelected'], false],
            ['literal', ['Open Sans Bold']],
            ['literal', ['Open Sans Regular']]
        ];
        options.textAllowOverlap = false;

         // zoom levels are built into tileset and not possible to change here.
        // https://docs.mapbox.com/help/troubleshooting/adjust-tileset-zoom-extent/
        options.visibleFrom = 4; // no impact
        options.visibleTo = 24; //  no impact

        options.visibility = true;
        options.textAnchor = 'bottom';
        options.textColor = this._theme === Theme.Light ? '#000000' : '#ffffff';
        options.textHaloColor = this._theme === Theme.Light ? '#ffffff' : '#000000';
        options.textHaloWidth = 1;
        options.textOpacity = ['step', ['zoom'], 0, 13, 0, 14.5, 1, 22, 1];
        options.customFilters = [['all'],
        ];

        // Position before Stops so Stops renders on top
        options.layerBefore = Layers.Stops;
        return options;
    }


    //#endregion

}


